import {createSelector} from '@ngrx/store';
import {selectAuthState} from '../../../core.state';
import {AuthState, UserAuthData} from '../reducers/auth.reducer';
import {
  ROLE_ADMIN, ROLE_OPERATORE, ROLE_USER,
  USER_ROLES
} from '../../../@types';
import * as moment from 'moment';

export const selectAuthUserData = createSelector(
  selectAuthState,
  (state: AuthState) => state.userAuthData
);

export const selectLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.loading
);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated
);

export const selectUserRole = createSelector(
  selectAuthState,
  (state: AuthState) => state.userAuthData.role
);

export const selectAnniTornei = createSelector(
  selectAuthState,
  (state: AuthState) => state?.anniTornei ?? [moment().year().toString()]
);

export const selectUserIsAmministratore = createSelector(
  selectUserRole,
  (role: USER_ROLES) => role === ROLE_ADMIN
);

export const selectUserIsOperatore = createSelector(
  selectUserRole,
  (role: USER_ROLES) => role === ROLE_OPERATORE
);

export const selectUserIsOperatoreOAmministratore = createSelector(
  selectUserRole,
  (role: USER_ROLES) => role === ROLE_ADMIN || role === ROLE_OPERATORE
);

export const selectLoginFormData = createSelector(
  selectAuthState,
  (state: AuthState) => state.loginFormData
);

export const selectAuthToken = createSelector(
  selectAuthUserData,
  (state: UserAuthData) => state?.Token ?? null
);


